<button class="e-feedback-button" [class.e-feedback-review-pending]="feedbackReviewPending"
    [attr.aria-label]="feedbackTooltipText" matTooltipClass="e-mat-tooltip" matTooltipPosition="below"
    matTooltip="{{feedbackTooltipText}}" matTooltipShowDelay="500" (click)="onSubmitFeedback($event)">
</button>
